import { logoutUser } from "../store/Auth/authThunks";
import store from "../store";

export async function handleAuthFailure(navigate, setSessionReason) {
  await store.dispatch(logoutUser());
  setSessionReason("Your session has expired. Please log in again.");
  navigate("/", { replace: true });
}
